<template>
  <el-row>
    <el-col :span="24">
      <div style="display: flex; justify-content: center; align-items: center; height: 24rem; padding-top: 5rem; background: url('../../../static/images/CustomerCase/CustomerCase_bg.png') 0% 0% / cover">

      </div>
    </el-col>
    <el-col :span="24">
      <div style="display: flex; justify-content: center; align-items: center; padding: 5rem 0 3rem 0">
        <el-tabs v-model="activeName" style="width: 1108px">
          <el-tab-pane label="BIM项目管控" name="first">
            <el-card style="margin-bottom: 2rem; height: 25rem">
              <div style="display: flex; justify-content: space-between; align-items: flex-start">
                <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 23.625rem">
                  <span style="font-size: 1.625rem; font-weight: 700; color: #f1781a">临港集团</span>
                  <span style="font-size: 1rem; font-weight: 700; color: #222; margin: 0.5rem 0 1rem 0">上海世外附属海口学校</span>
                  <div style="font-size: 0.875rem; font-weight: 400; color: #888; text-align: left; line-height: 1.5rem">
                    上海世外附属海口学校项目位于海口市秀英区美安生态科技新城内。要求提供BIM总顾问服务。通过引入BIM技术，使用BIM项目管理协同平台，开展基于BIM技术的设计、施工一体化应用，充分考虑项目贯通运营的要求，以实现工程数字化运维管理为目标。在保证交付的工程设计施工一体化成果统一的基础上，通过数字化移交技术实现实物资产和全信息数字化虚拟资产的整体移交，全面提高上海世外附属海口学校项目投运速度，实现校园智慧运营。
                  </div>
                </div>
                <el-image src="../../../static/images/CustomerCase/CustomerCase_001.png" style="width: 39rem; height: 22rem"></el-image>
              </div>
            </el-card>
            <el-card style="margin-bottom: 2rem; height: 25rem">
              <div style="display: flex; justify-content: space-between; align-items: flex-start">
                <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 23.625rem">
                  <span style="font-size: 1.625rem; font-weight: 700; color: #f1781a">中建国际建设有限公司</span>
                  <span style="font-size: 1rem; font-weight: 700; color: #222; margin: 0.5rem 0 1rem 0">年度BIM咨询服务+BIM项目管控平台</span>
                  <div style="font-size: 0.875rem; font-weight: 400; color: #888; text-align: left; line-height: 1.5rem">
                    为满足中建国际建设有限公司的年度多个建设项目的BIM应用需求，通过BIM技术+ BIM协同平台，结合现场管理指导BIM应用，提供BIM实施、进度、质量、安全等管理动作的数据支持，解决施工现场实际问题，减少设计变更，提高施工质量，加快施工进度，节约施工成本，并能够对施工过程资料进行有效管理，便于后续运维阶段的管理。
                  </div>
                </div>
                <el-image src="../../../static/images/CustomerCase/CustomerCase_002.png" style="width: 39rem; height: 22rem"></el-image>
              </div>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="数智企业" name="second">
            <el-card style="margin-bottom: 2rem; height: 25rem">
              <div style="display: flex; justify-content: space-between; align-items: flex-start">
                <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 23.625rem">
                  <span style="font-size: 1.625rem; font-weight: 700; color: #f1781a">中铁建设南方公司</span>
                  <span style="font-size: 1rem; font-weight: 700; color: #222; margin: 0.5rem 0 1rem 0">企业数智化信息系统</span>
                  <div style="font-size: 0.875rem; font-weight: 400; color: #888; text-align: left; line-height: 1.5rem">
                    推行以数字技术为核心基础，研发协同办公管理系统，采用Web端与移动端相配合的创新管理模式，打造数字化工地，推进管理升级，主动适应数智化管理要求。通过该管理系统，提高岗位人员工作效率，消除项目各方沟通壁垒，辅助管理层经营决策，从而实现项目精细化管理和企业集约化管理。
                  </div>
                </div>
                <el-image src="../../../static/images/CustomerCase/CustomerCase_003.png" style="width: 39rem; height: 22rem"></el-image>
              </div>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="智慧教育" name="third">
            <el-card style="margin-bottom: 2rem; height: 25rem">
              <div style="display: flex; justify-content: space-between; align-items: flex-start">
                <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 23.625rem">
                  <span style="font-size: 1.625rem; font-weight: 700; color: #f1781a">广西建设职业技术学院</span>
                  <span style="font-size: 1rem; font-weight: 700; color: #222; margin: 0.5rem 0 1rem 0">BIM魔方智能教学平台</span>
                  <div style="font-size: 0.875rem; font-weight: 400; color: #888; text-align: left; line-height: 1.5rem">
                    通过 BIM 技术、互联网信息技术、AI智能化技术等当前主流技术搭建基于BIM模型的智能教学系统，开展相关工程建筑和BIM技术类课程的教学资源管理、课程学习、智能问答、自动考核评价等，协助广西建设职业技术学院推进全国职业院校教师教学创新团队的工作，加快中国特色高水平专业建设步伐，打造国家级执教团队，提高“1+X”职业教育工程建筑类专业教育的教学质量和智能化水平。
                  </div>
                </div>
                <el-image src="../../../static/images/CustomerCase/CustomerCase_004.png" style="width: 39rem; height: 22rem"></el-image>
              </div>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="BIM工具" name="fourth">
            <el-card style="margin-bottom: 2rem; height: 25rem">
              <div style="display: flex; justify-content: space-between; align-items: flex-start">
                <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 23.625rem">
                  <span style="font-size: 1.625rem; font-weight: 700; color: #f1781a">碧桂园</span>
                  <span style="font-size: 1rem; font-weight: 700; color: #222; margin: 0.5rem 0 1rem 0">BIM构件库信息管理平台</span>
                  <div style="font-size: 0.875rem; font-weight: 400; color: #888; text-align: left; line-height: 1.5rem">
                    碧桂园设计院及慧城建筑科技有限公司创建了大量符合BIM标准的Revit族，期望采用系统化的手段对Revit族进行集中管理，便于企业的BIM设计数据收集与整合。通过建立企业级BIM构件库信息管理平台，集中管理符合BIM标准的构件，有利于专业设计人员专注于设计，方便公司内部和项目各参建方使用，提高企业的设计标准化水平和设计质量。
                  </div>
                </div>
                <el-image src="../../../static/images/CustomerCase/CustomerCase_005.png" style="width: 39rem; height: 22rem"></el-image>
              </div>
            </el-card>
            <el-card style="margin-bottom: 2rem; height: 25rem">
              <div style="display: flex; justify-content: space-between; align-items: flex-start">
                <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 23.625rem">
                  <span style="font-size: 1.625rem; font-weight: 700; color: #f1781a">山西省电力勘测设计院</span>
                  <span style="font-size: 1rem; font-weight: 700; color: #222; margin: 0.5rem 0 1rem 0">变电工程三维设计过程管控</span>
                  <div style="font-size: 0.875rem; font-weight: 400; color: #888; text-align: left; line-height: 1.5rem">
                    设计院采用基于Revit开发的STD-R三维设计平台实现电力三维设计，并且自主研发了相对成熟的设计校审管理平台。为保障三维设计质量，在实现多专业三维数字化设计的同时，解决多专业、多文件格式协同校审的技术难题，需要打通STD-R三维设计平台与自有设计校审管理平台，实现进行数据交互。
                  </div>
                </div>
                <el-image src="../../../static/images/CustomerCase/CustomerCase_006.png" style="width: 39rem; height: 22rem"></el-image>
              </div>
            </el-card>
            <el-card style="margin-bottom: 2rem; height: 25rem">
              <div style="display: flex; justify-content: space-between; align-items: flex-start">
                <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 23.625rem">
                  <span style="font-size: 1.625rem; font-weight: 700; color: #f1781a">江苏省电力设计院</span>
                  <span style="font-size: 1rem; font-weight: 700; color: #222; margin: 0.5rem 0 1rem 0">BIM应用工具集开发</span>
                  <div style="font-size: 0.875rem; font-weight: 400; color: #888; text-align: left; line-height: 1.5rem">
                    随着信息化、数字化、智能化技术发展，深化数字化设计、推进智慧工地建设已成为加快电力建造方式转型升级的突破口和着力点。通过BIM应用工具集，积极探索三维数字化设计深化应用、智慧工地建设。
                  </div>
                </div>
                <el-image src="../../../static/images/CustomerCase/CustomerCase_007.png" style="width: 39rem; height: 22rem"></el-image>
              </div>
            </el-card>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-col>
  </el-row>
</template>

<script>
    export default {
        name: "CustomerCase",
        data: function () {
          return {
            activeName: 'first'
          }
        },
        components: {

        },
        created() {
        },
        mounted() {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        methods: {

        }
    }
</script>

<style scoped>
  .el-main > .el-row {
    min-width: 1108px;
  }

  .el-row /deep/ .el-tabs__nav-wrap::after {
    display: none;
  }

  .el-row /deep/ .el-tabs__header {
    margin: 0 0 1.5rem;
    padding: 0 1rem;
  }

  .el-row /deep/ .el-tabs__active-bar {
    background-color: #f1781a
  }

  .el-row /deep/ .el-tabs__item:hover,
  .el-row /deep/ .el-tabs__item:focus,
  .el-row /deep/ .el-tabs__item.is-active {
    font-weight: 700;
    color: #f1781a;
  }

  .el-row /deep/ .el-card__body {
    padding: 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/CustomerCase.vue